// frontend/src/common/ui/PractitionerCard.jsx
import { Badge, Button, StatusBadge } from "@common";
import { safeText } from "@utils/utils";

export default function PractitionerCard({
  practitioner,
  typeUi,
  status,
  badgeColor = "neutral",

  // Existing (kept)
  actionLabel = "Edit",
  onAction,

  // ✅ NEW
  viewLabel = "View",
  onView,
}) {
  const name = safeText(practitioner?.name) || "—";

  return (
    <div className="group relative w-full">
      {/* Top row: avatar + name/status */}
      <div className="flex items-start gap-3">
        <div className="h-12 w-12 rounded-full bg-palette-gray-divider flex items-center justify-center shrink-0">
          <svg
            viewBox="0 0 24 24"
            className="h-7 w-7 text-palette-gray-placeholder"
            fill="currentColor"
          >
            <path d="M12 12a4 4 0 10-4-4 4 4 0 004 4zm0 2c-4.42 0-8 2-8 4.5A1.5 1.5 0 005.5 20h13a1.5 1.5 0 001.5-1.5C20 16 16.42 14 12 14z" />
          </svg>
        </div>

        <div className="min-w-0 flex-1">
          <div className="truncate text-sm font-semibold text-palette-slate-primary">{name}</div>

          {/* Status only */}
          <div className="mt-1">
            <StatusBadge status={status} variant="dot" />
          </div>
        </div>
      </div>

      {/* Actions + Badge bottom-right */}
      <div className="mt-6 flex justify-end items-center gap-3">
        {/* ✅ View (left) */}
        {onView && (
          <Button
            type="button"
            variant="link"
            size="sm"
            onClick={(e) => {
              e.stopPropagation();
              onView?.(practitioner);
            }}
            className="
              text-xs font-semibold
              text-palette-slate-badge hover:text-palette-slate-text hover:underline
              opacity-100 md:opacity-0 md:group-hover:opacity-100 md:group-focus-within:opacity-100
              transition
            "
            title={viewLabel}
          >
            {viewLabel}
          </Button>
        )}

        {/* Existing Edit/View action (right of View) */}
        {onAction && (
          <Button
            type="button"
            variant="link"
            size="sm"
            onClick={(e) => {
              e.stopPropagation();
              onAction?.(practitioner);
            }}
            className="
              text-xs font-semibold
              opacity-100 md:opacity-0 md:group-hover:opacity-100 md:group-focus-within:opacity-100
              transition
            "
            title={actionLabel}
          >
            {actionLabel}
          </Button>
        )}

        <Badge color={badgeColor}>{typeUi || "—"}</Badge>
      </div>
    </div>
  );
}
